import { createAsyncThunk } from '@reduxjs/toolkit';

import { usersService } from 'services';
import { User } from 'interfaces';

export const getUser = createAsyncThunk<User>(
  'user/get',
  async (_, { rejectWithValue }) => {
    try {
      if (
        !localStorage.getItem('accessToken') &&
        !localStorage.getItem('accessToken')
      )
        return rejectWithValue('no auth');

      return usersService.getUser();
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
